import { render, staticRenderFns } from "./JobInfoTab.vue?vue&type=template&id=54aca58f&scoped=true&"
import script from "./JobInfoTab.vue?vue&type=script&lang=js&"
export * from "./JobInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./JobInfoTab.vue?vue&type=style&index=0&id=54aca58f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aca58f",
  null
  
)

export default component.exports